define('shared/remote/member/house',[
    '../ajax',
    'Promise'
], function(
    ajax,
    Promise
){
    var URL = '/checkout/house-login-dispatcher-v2.ashx';
    var cache = {};

    var ret = function(options) {
        if (!options.email) {
            return Promise.reject({
                prop: 'email',
                missing: true,
                toString: function() {
                    return 'Email is missing';
                }
            });
        }

        if (cache[options.email] != null) {
            return Promise.resolve(cache[options.email]);
        }

        return Promise.resolve()
            .then(function(){
                return ajax({
                    url: URL + '?' + 
                        [
                            'email=' + 
                                encodeURIComponent(options.email)
                        ].join('&'),
                    method: 'GET',
                    dataType: 'json'
                })
                .then(function(json){
                    if (
                        !json ||
                        !json.result) {
                        throw 'Unexpected result returned from server';
                    }

                    return json.result.toLowerCase();
                });
            })
            .then(function(value){
                cache[options.email] = value;
                return value;
            });
    };

    ret.OLD = 'loginoh';
    ret.NEW = 'loginnh';
    ret.NOT_EXIST = 'notexist';
    ret.RE_REGISTER = 'reregister';

    return ret;
});
